import { Button } from '@rumblefish/ui/Rumblefish23Theme';
import { handleScroll } from '../../../utils/handleScroll';
import {
  StyledContainer,
  StyledSection,
  StyledSectionTitle,
  StyledTypography,
} from './styles';

export const EmptyCurrentOpenings: React.FC = () => {
  const scrollToContactForm = () => {
    const targetElement = document.getElementById('contact-form');
    if (targetElement) {
      handleScroll({ current: targetElement });
    }
  };
  return (
    <StyledSection width="normal" id="current-openings-empty">
      <StyledSectionTitle variant="display_sm">Job openings</StyledSectionTitle>
      <StyledContainer>
        <StyledTypography variant="body2">
          We are not looking for any specific roles at this moment, but please
          send us your resume and let's stay in touch for future openings
        </StyledTypography>
        <Button
          secondaryVariant
          shadowColor="orange"
          onClick={scrollToContactForm}>
          Submit your application
        </Button>
      </StyledContainer>
    </StyledSection>
  );
};
